import {
  trigger,
  transition,
  style,
  query,
  animate,
  group,
} from '@angular/animations';

export const routeTransition = trigger('routeTransition', [
  transition('* <=> *', [
    query(':enter, :leave', [
      style({
        position: 'absolute',
        top: 0,
        left: 0,
        width: '100%',
        height: '100%',
      }),
    ], { optional: true }),

    group([
      query(':leave', [
        style({ opacity: 1, transform: 'scale(1)' }),
        animate('200ms ease-out', style({
          opacity: 0,
          transform: 'scale(0.98)',
        })),
      ], { optional: true }),

      query(':enter', [
        style({ opacity: 0, transform: 'scale(1.01)' }),
        animate('250ms 100ms ease-out', style({
          opacity: 1,
          transform: 'scale(1)',
        })),
      ], { optional: true }),
    ]),
  ]),
]);
